export const timeRanges = [
  {
    sameDayEligible: true,
    type: 'immediate',
    label: 'Immediately needed',
    requiresConfirm: false,
    start: 6,
    end: 18,
    weekend: false,
  },
  {
    sameDayEligible: true,
    type: 'range',
    label: '6:00 AM - 6:00 PM',
    requiresConfirm: false,
    start: 6,
    end: 18,
    weekend: false,
  },
  {
    sameDayEligible: false,
    type: 'range',
    label: '9:00 AM - 12:00 PM',
    requiresConfirm: false,
    start: 9,
    end: 12,
    weekend: false,
  },
  {
    sameDayEligible: false,
    type: 'range',
    label: '6:00 AM - 8:00 AM',
    requiresConfirm: true,
    start: 6,
    end: 8,
    weekend: false,
  },
  {
    sameDayEligible: true,
    type: 'range',
    label: '12:00 PM - 5:00 PM',
    requiresConfirm: false,
    start: 12,
    end: 17,
    weekend: false,
  },
  {
    sameDayEligible: true,
    type: 'range',
    label: '5:00 PM - 8:00 PM',
    requiresConfirm: true,
    start: 17,
    end: 20,
    weekend: false,
  },
];
